import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { showErrorToast, showSuccessToast } from '../../utils/errorHandling';
import { superAdminAPI } from '../../services/api';
import QuestionForm from '../shared/QuestionForm';

const CreateQuestion = () => {
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(true);

  const handleCreateDraftQuestion = async (questionData) => {
    try {
      // Create draft question using the content generator API
      await superAdminAPI.createContentGeneratorQuestion(questionData);
      showSuccessToast('Draft question created successfully');
      navigate('/content-generator/my-questions');
    } catch (error) {
      console.error('Error creating draft question:', error);
      showErrorToast(error);
      throw error; // Re-throw to prevent modal from closing
    }
  };

  const handleClose = () => {
    setShowCreateModal(false);
    navigate('/content-generator/my-questions');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/content-generator/my-questions')}
                className="mr-4 p-2 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div className="flex items-center">
                <FileText className="w-6 h-6 text-blue-600 mr-3" />
                <h1 className="text-xl font-semibold text-gray-900">Create Draft Question</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-6">
            <h2 className="text-lg font-medium text-gray-900 mb-2">Create New Draft Question</h2>
            <p className="text-sm text-gray-600">
              Create a draft question that will be reviewed by content reviewers and approved by content supervisors before becoming a published question.
            </p>
          </div>

          <button
            onClick={() => setShowCreateModal(true)}
            className="w-full px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center justify-center"
          >
            <FileText className="w-5 h-5 mr-2" />
            Start Creating Draft Question
          </button>
        </div>
      </div>

      {/* Question Form Modal */}
      <QuestionForm
        isOpen={showCreateModal}
        onClose={handleClose}
        onSubmit={handleCreateDraftQuestion}
        title="Create Draft Question"
        submitButtonText="Create Draft Question"
        isDraft={true}
      />
    </div>
  );
};

export default CreateQuestion;
